export function LoadingText({ text = "Loading...", className = "" }: { text?: string, className?: string }) {
    return (
        <span className={className}>
            <span
                className={`spinner-border spinner-border-sm ${text ? "me-2" : ""}`}
                role="status"
                aria-hidden="true"
            ></span>{text}
        </span>
    );
}
